var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 17C20.9469 17 20.5 17.4469 20.5 18V24.5H19.25C18.8344 24.5 18.5 24.8344 18.5 25.25C18.5 25.6656 18.8344 26 19.25 26H20.5V27.5H19.25C18.8344 27.5 18.5 27.8344 18.5 28.25C18.5 28.6656 18.8344 29 19.25 29H20.5V30C20.5 30.5531 20.9469 31 21.5 31C22.0531 31 22.5 30.5531 22.5 30V29H27.25C27.6656 29 28 28.6656 28 28.25C28 27.8344 27.6656 27.5 27.25 27.5H22.5V26H26C28.4844 26 30.5 23.9844 30.5 21.5C30.5 19.0156 28.4844 17 26 17H21.5ZM26 24H22.5V19H26C27.3813 19 28.5 20.1188 28.5 21.5C28.5 22.8812 27.3813 24 26 24Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRub);
export default __webpack_public_path__ + "static/media/rub.425e68dddc6c51e992162b4570c4d8cc.svg";
export { ForwardRef as ReactComponent };